module.exports = __webpack_public_path__ + "static/media/Badge_SvgExpertCategoriel_Theme.c71c7ee2.png";